import Reveal from '@/components/base/Reveal';
import { reversalChecks } from '@/mocks/tracking';

export default function Reversal() {
  return (
    <section id="reversal" className="bg-accent-50/45">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <div className="lg:sticky lg:top-24">
              <p className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">预警机制</p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">反转观察</h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                反转可能是一个概率问题，不是立场问题。我们把每个事件拆成可核对的疑点，用公开证据的推进程度来估算反转指数，而不是靠感觉带节奏。
              </p>
              <div className="mt-6 rounded-lg border border-accent-200 bg-background-50 p-4">
                <p className="flex items-center gap-2 font-label text-xs font-semibold text-accent-800">
                  <i className="ri-error-warning-line text-sm" />
                  口径 ≠ 结论
                </p>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                  指数越高代表“已出现支持原爆料方向的证据越多”。指数会随新证据上下浮动，属于阶段性判断。
                </p>
              </div>
            </div>
          </Reveal>

          <div className="space-y-5 lg:col-span-8">
            {reversalChecks.map((check, idx) => (
              <Reveal key={check.id} delay={idx * 80}>
                <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                  <div className="flex flex-wrap items-center justify-between gap-3">
                    <h3 className="font-heading text-base font-bold text-foreground-950">{check.label}</h3>
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 font-label text-xs font-medium text-accent-800">
                      <i className="ri-restart-line" />
                      {check.verdict}
                    </span>
                  </div>

                  <div className="mt-5">
                    <div className="flex items-center justify-between font-label text-xs text-foreground-600">
                      <span>反转可能指数</span>
                      <span className="font-semibold text-accent-700">{check.percent}%</span>
                    </div>
                    <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-accent-500 transition-all"
                        style={{ width: `${check.percent}%` }}
                      />
                    </div>
                  </div>

                  <ul className="mt-5 space-y-2.5">
                    {check.points.map((point) => (
                      <li key={point} className="flex items-start gap-2 text-sm text-foreground-700">
                        <i className="ri-checkbox-blank-circle-line mt-0.5 text-xs text-foreground-400" />
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}